import { IVehicle } from "@/types/vehicle.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";
import { getCompanyId } from "./company.api";
import { IRenter } from "@/types/renter.type";

const API_URL = `${import.meta.env.VITE_API_URL}/precollection`;
const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function preUnlinkVehicleRenter(data) {
  const url = `${API_URL}/unlink-vehicle`;

  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...data, companyId: getCompanyId() }),
  };

  const result = makeRequestDebounced(url, options) as Promise<ApiResponseType<unknown>>;

  return result;
}

export async function getVehicleList() {
  const url = `${API_URL}/vehicles-list`;
  const result = await makeRequest<IVehicle[]>(url);

  return { ok: result.ok, data: result.data };
}

export async function getRenterByDocument(document: string) {
  const url = `${API_URL}/renter/cpf/${document}`;
  const result = await makeRequest<IRenter>(url);

  return { ok: result.ok, data: result.data };
}

interface SendFileRequest {
  vehicleId: string;
  licensePlate: string;
  collector?: {
    name: string;
    document: string;
    selfieWithAddress: string;
    location?: { mapsUrl: string; latitude: number; longitude: number; currentTime: Date };
  };
}

export async function sendRenterSelfieWithAddress(renterId: string, data: SendFileRequest) {
  const { vehicleId, licensePlate, collector } = data;

  const url = `${API_URL}/renter/${renterId}/selfie-with-address`;

  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ vehicleId, licensePlate, collector }),
  };

  const result = await makeRequest<ApiResponseType<unknown>>(url, options);

  return { ok: result.ok, data: result.data };
}
